function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { definePropType } from "@types-vue/props";
import TableList from "@pt/views/pt-entry/components/table-list.vue";
import Pagination from "@pt/views/pt-entry/components/pagination/index.vue";
import SearchInput from "@pt/components/search-input.vue";
import EmptyView from "@pt/views/pt-entry/components/empty-view.vue";
import NameId from "@pt/views/pt-entry/components/name-id.vue";
import imageNotFound from "@com/assets/default_small.png";
import { defineComponent, // onMounted,
// computed,
ref, watch, // reactive,
// toRefs,
getCurrentInstance } from "vue";
import format from "date-fns/format/index.js";
import { getPlatformInfo, getProductType } from "@pt/views/pt-entry/common-setting/promote-product/promote-product";
import { t } from "@/lang";
var defaultQuery = {
    page: 1,
    page_size: 10,
    name: ""
};
export default defineComponent({
    components: {
        TableList: TableList,
        Pagination: Pagination,
        SearchInput: SearchInput,
        EmptyView: EmptyView,
        NameId: NameId
    },
    props: {
        remoteMethod: {
            type: definePropType(Function),
            required: true
        },
        optionsTotal: {
            type: Number,
            required: true
        },
        options: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        selectedOption: {
            type: definePropType(null),
            required: true
        }
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var dialogVisible = ref(false);
        var tableConfig = {};
        var query = ref(_objectSpread({}, defaultQuery));
        var columnConfig = [
            {
                prop: "name",
                slot: "name"
            },
            {
                prop: "type",
                label: t("playTurbo.assetLibrary.asset.filter.types"),
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        return getProductType(row.type);
                    }
                }
            },
            {
                prop: "platforms",
                slot: "platforms"
            },
            {
                prop: "updated_time",
                slot: "updated_time",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        return format(row.updated_time * 1000, "YYYY/MM/DD HH:mm");
                    }
                }
            },
            {
                prop: "action",
                slot: "action"
            }, 
        ];
        var handleCurrentChange = function(page) {
            query.value.page = page;
            props.remoteMethod(query.value);
        };
        var resetQuery = function() {
            query.value = _objectSpread({}, defaultQuery);
        };
        var closeDialog = function() {
            dialogVisible.value = false;
            resetQuery();
        };
        var handleClearSelect = function() {
            emit("select", null);
        };
        var showDialog = function() {
            dialogVisible.value = true;
        };
        // 设计要求页面展示后，弹窗高度固定
        var fixedDialogHeight = function() {
            var dom = document.querySelector(".product-selector-dialog-inner .product-bd");
            if (dom) {
                dom.style.height = "".concat(dom.offsetHeight, "px");
            }
        };
        var handleSearch = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return props.remoteMethod(query.value);
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleSearch() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleSelect = function(row) {
            emit("select", row);
            setTimeout(function() {
                dialogVisible.value = false;
            }, 0);
        };
        watch(function() {
            return dialogVisible.value;
        }, function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(val) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!val) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 3;
                            return handleSearch();
                        case 3:
                            root.$nextTick(function() {
                                fixedDialogHeight();
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(val) {
                return _ref.apply(this, arguments);
            };
        }());
        return {
            dialogVisible: dialogVisible,
            tableConfig: tableConfig,
            query: query,
            columnConfig: columnConfig,
            imageNotFound: imageNotFound,
            closeDialog: closeDialog,
            handleSearch: handleSearch,
            handleCurrentChange: handleCurrentChange,
            handleClearSelect: handleClearSelect,
            handleSelect: handleSelect,
            showDialog: showDialog,
            format: format,
            getPlatformInfo: getPlatformInfo
        };
    }
});
